import React from "react";
//#region types
import { SalaryDeviationFormTypes } from "models/formTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { DeviationMonthProps } from "models/propTypes/salaryDeviationPropTypes";
//#endregion
//#region components
import { useFilterContext, useMountedState } from "components/common";
import { useSalaryDeviationsService } from "serviceHooks";
//#endregion
import { DateHelper } from "utils/helpers";

const DeviationMonth: React.FC<DeviationMonthProps> = (props) => {
  const salaryDeviationsService = useSalaryDeviationsService();
  const { reloadKey, render } = props;
  const { filter } = useFilterContext<SalaryDeviationFormTypes.Filter>();
  const { getMounted } = useMountedState();

  const [deviationMonth, setDeviationMonth] = React.useState<WintSuperkollAPIModel.SalaryDeviationMonth>();
  const [isAllowedToSubmit, setIsAllowedToSubmit] = React.useState<boolean>();

  const filterYearMonth = filter?.yearAndMonth ? DateHelper.getYearMonth(filter.yearAndMonth) : undefined;
  const currentYearMonth = DateHelper.getYearMonth(DateHelper.today());

  const loadDeviationMonth = (forceRefresh?: boolean) => {
    if (!filter?.personName && filter?.yearAndMonth) {
      if (forceRefresh || deviationMonth?.yearAndMonth !== filterYearMonth) {
        setDeviationMonth(undefined);
        setIsAllowedToSubmit(undefined);
        salaryDeviationsService.getMonth(filterYearMonth!).then((res) => {
          if (getMounted()) {
            setDeviationMonth(res.data);
            const isPresentOrFutureMonth = currentYearMonth < filterYearMonth! || currentYearMonth === filterYearMonth!;
            setIsAllowedToSubmit(!isPresentOrFutureMonth && !salaryDeviationsService.isMonthDisabled(res.data.state));
          }
        });
      }
    } else {
      setDeviationMonth(undefined);
      setIsAllowedToSubmit(false);
    }
  };

  React.useEffect(() => {
    loadDeviationMonth();
  }, [filter]);

  React.useEffect(() => {
    loadDeviationMonth(true);
  }, [reloadKey]);

  return <>{render(deviationMonth, isAllowedToSubmit)}</>;
};

export default DeviationMonth;
